import React from 'react'
import './Customers.css'

const Customers = ({ topCompanies }) => {
    const companies = topCompanies?.company_details ?? []

    return (
        <div className="container" style={{ marginTop: '1%', marginBottom: '2%' }}>
            <h3 className="data_header">Customers</h3>
            {companies.length > 0 ? (
                companies.map((company, i) => (
                    <div className="company_name" key={i}>
                        <span>{company.company_name}</span>
                    </div>
                ))
            ) : (
                <div className="undefined">
                    <p>Details not available</p>
                </div>
            )}
        </div>
    )
}

export default Customers
